import { render } from "./AssetMap2.vue?vue&type=template&id=10fd1668&scoped=true"
import script from "./AssetMap2.vue?vue&type=script&lang=js"
export * from "./AssetMap2.vue?vue&type=script&lang=js"

import "./AssetMap2.vue?vue&type=style&index=0&id=10fd1668&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10fd1668"]])

export default __exports__